import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbTrail = ({ className = '' }) => {
  const location = useLocation();

  const breadcrumbMap = {
    '/dashboard-overview': 'داشبورد',
    '/new-request-form': 'درخواست جدید',
    '/requests-management': 'مدیریت درخواست‌ها',
    '/payments': 'پرداخت‌ها',
  };

  const pathSegments = location?.pathname?.split('/')?.filter(Boolean);

  // Build breadcrumb items
  const breadcrumbItems = [{ label: 'خانه', path: '/dashboard-overview' }];

  let currentPath = '';
  pathSegments?.forEach((segment) => {
    currentPath += `/${segment}`;
    if (breadcrumbMap?.[currentPath] && currentPath !== '/dashboard-overview') {
      breadcrumbItems?.push({
        label: breadcrumbMap?.[currentPath],
        path: currentPath,
      });
    }
  });

  // Don't show breadcrumbs if we're on the dashboard (home page)
  if (breadcrumbItems?.length <= 1) {
    return null;
  }

  return (
    <nav
      className={`flex items-center space-x-2 space-x-reverse text-sm text-muted-foreground mb-6 ${className}`}
      aria-label="مسیر صفحه">
      {breadcrumbItems?.map((item, index) => (
        <React.Fragment key={item?.path}>
          {index === breadcrumbItems?.length - 1 ? (
            // Current page - not clickable
            <span className="text-foreground font-medium">{item?.label}</span>
          ) : (
            // Previous pages - clickable
            <Link
              to={item?.path}
              className="hover:text-foreground transition-colors duration-150">
              {item?.label}
            </Link>
          )}

          {index < breadcrumbItems?.length - 1 && (
            <Icon
              name="ChevronLeft"
              size={16}
              className="text-muted-foreground rotate-180"
            />
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default BreadcrumbTrail;
